import {
  Alert,
  Autocomplete,
  Button,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  Pagination,
  Snackbar,
  Tab,
  Tabs,
  TextField,
  Tooltip,
} from "@mui/material";
import { Box } from "@mui/system";

import { useTheme } from "@emotion/react";
import {
  AccessTimeOutlined,
  AddOutlined,
  CheckOutlined,
  Clear,
  ClearOutlined,
  DateRangeOutlined,
  ErrorOutlineOutlined,
  EventRepeatOutlined,
  ManageHistoryOutlined,
  PersonPinCircleOutlined,
  SupportAgentOutlined,
  TroubleshootOutlined,
  TurnSlightRightOutlined,
} from "@mui/icons-material";
import useStyles from "./styles";

import { useEffect, useState } from "react";

import { useOutletContext } from "react-router-dom";

import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import ButtonTime from "../../../../components/buttonTime";
import CardsStatusTicketComponet from "../../../../components/tickets/cardsStatusTicketComponent";
import FilterBar from "../../../../components/topBarFilter";

import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ConfusedMale from "../../../../components/artsPersonComponent/confusedMale";
import InformationMale from "../../../../components/artsPersonComponent/informationMale";
import LoaderThreeDots from "../../../../components/loadingAnimation";
import VirtualizedAutocomplete from "../../../../components/virtualization/virtualizedAutocomplete";
import TicketComponentIxc from "../../../../components/tickets/ticketComponentIxc";
import ModalNewTicketIxc from "../../../../components/tickets/modalNewTicketIxc";
import ErpFilter from "../../../../components/erp/ErpFilter";
import useErpSelecionado from "../../../../components/erp/useErpSelecionado";
import { tiposDaTela } from "../../../../services/telasErp";
import {
  CampoCliente,
  renderOpcaoCliente,
} from "../../../../components/opcaoCliente";
import { getClienteOptionLabel } from "../../../../components/grupoEconomico/helpers";
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
export default function Os(params) {
  // ERP escolhido (só os tipos que têm a tela); todas as consultas levam o erpId.
  const { erps, erpId, setErpId, erp, carregado, variosErps } =
    useErpSelecionado(tiposDaTela("/interno/suporte/os"));
  const labelErp =
    erp === "HUBSOFT"
      ? "Serviços"
      : erp === "VOALLE"
        ? "Contrato"
        : erp === "IXC"
          ? "Contrato"
          : "Serviços";
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [loading, setLoading] = useState(false);
  const [clientes, setClientes] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [ticketsAbertos, setTicketsAbertos] = useState([]);
  const [ticketsResolvidos, setTicketsResolvidos] = useState([]);
  const [value, setValue] = useState(0);
  const [selectTime, setSelectTime] = useState(8);
  const [page, setPage] = useState(1);
  const [allTickets, setAllTickets] = useState({});
  const [buscarTicket, setBuscarTicket] = useState("");
  const [isValidRange, setIsValidRange] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [selectedCliente, setSelectedCliente] = useState(null);
  const [selectedService, setSelectedService] = useState("");
  const [loadingGetTickets, setLoadingGetTickets] = useState(false);
  const [openNewTicket, setOpenNewTicket] = useState(false);
  const [filterData, setFilterData] = useState({
    initialDate: dayjs()
      .subtract(30, "day")
      .set("second", 0)
      .set("millisecond", 0)
      .toDate(),
    finalDate: dayjs().set("second", 0).set("millisecond", 0).toDate(),
  });
  const [allServicesCliente, setAllServiceCliente] = useState([]);
  const [loadingService, setLoadingService] = useState(false);
  const [snackbar, setSnackbar] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const open = Boolean(anchorEl);
  const theme = useTheme();

  const styles = useStyles(theme);
  const itemsPerPage = 12;
  const { controllerDashboard, setControllerDashboard, api } =
    useOutletContext();
  const [countTickets, setContTickets] = useState({});
  const configErp = (invertInfo) => {
    switch (erp) {
      case "HUBSOFT":
        return {
          labelRef: invertInfo ? "Serviço" : "Referência",
        };
        break;
      case "IXC":
        return {
          labelRef: invertInfo ? "Contrato" : "Descrição auxiliar",
        };
        break;
      default:
        return {
          labelRef: "",
        };
        break;
    }
  };
  const optionsTime = {
    0: {
      value: dayjs()
        .subtract(5, "minute")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Todos",
    },
    1: {
      value: dayjs()
        .subtract(1, "hour")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Última hora",
    },
    2: {
      value: dayjs()
        .subtract(3, "hour")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimas 3 horas",
    },
    3: {
      value: dayjs()
        .subtract(6, "hour")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimas 6 horas",
    },
    4: {
      value: dayjs()
        .subtract(12, "hour")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimas 12 horas",
    },
    5: {
      value: dayjs()
        .subtract(24, "hour")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimas 24 horas",
    },
    6: {
      value: dayjs()
        .subtract(2, "day")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 2 dias",
    },
    7: {
      value: dayjs()
        .subtract(7, "day")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 7 dias",
    },
    8: {
      value: dayjs()
        .subtract(30, "day")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 30 dias",
    },
    9: {
      value: dayjs()
        .subtract(90, "day")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 90 dias",
    },
    10: {
      value: dayjs()
        .subtract(6, "month")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 6 meses",
    },
  };

  const currentList =
    value === 0
      ? ticketsAbertos
      : value === 1
        ? ticketsResolvidos
        : value === 2
          ? tickets
          : [];
  const filteredRows = currentList?.filter((row) => {
    const search = buscarTicket?.toLowerCase()?.trim() || "";

    const matchesSearch =
      row?.usuario_abertura?.toLowerCase()?.includes(search) ||
      row?.protocolo?.toLowerCase()?.includes(search) ||
      row?.data_cadastro?.toLowerCase()?.includes(search) ||
      row?.descricao_abertura?.toLowerCase()?.includes(search) ||
      row?.status?.toLowerCase()?.includes(search) ||
      row?.servico?.id_cliente_servico
        ?.toString()
        ?.toLowerCase()
        ?.includes(search) ||
      row?.setor?.toLowerCase()?.includes(search) ||
      row?.assunto?.toLowerCase()?.includes(search) ||
      row?.id_ticket?.toString()?.includes(search) ||
      row?.filial?.toLowerCase()?.includes(search);

    const matchesSelectedService = selectedService
      ? row?.servico?.id_cliente_servico?.toString() ===
        selectedService?.toString()
      : true;

    return matchesSearch && matchesSelectedService;
  });
  const totalPages = Math.ceil((filteredRows?.length || 0) / itemsPerPage);
  const paginatedRows = filteredRows?.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage,
  );

  useEffect(() => {
    setTickets(allTickets?.atendimentos);
    setTicketsAbertos(allTickets?.statusSeparado?.abertos);
    setTicketsResolvidos(allTickets?.statusSeparado?.resolvidos);
    let initialCount = {};

    let statusCounts = {};

    switch (erp) {
      case "HUBSOFT":
        initialCount = {
          pendente: 0,
          resolvido: 0,
          agdAnalise: 0,
        };

        statusCounts = allTickets?.atendimentos?.reduce(
          (acc, item) => {
            switch (item.status) {
              case "Pendente":
                acc.pendente++;
                break;
              case "Resolvido":
                acc.resolvido++;
                break;
              case "Aguardando Análise":
                acc.agdAnalise++;
                break;
              default:
                break;
            }
            return acc;
          },
          { ...initialCount },
        );

        setContTickets({
          pendente: statusCounts?.pendente || 0,
          resolvido: statusCounts?.resolvido || 0,
          agdAnalise: statusCounts?.agdAnalise || 0,
          total:
            statusCounts?.pendente +
              statusCounts?.resolvido +
              statusCounts?.agdAnalise || 0,
        });
        break;
      case "VOALLE":
        initialCount = {
          pendente: 0,
          resolvido: 0,
          agdAnalise: 0,
        };

        statusCounts = allTickets?.atendimentos?.reduce(
          (acc, item) => {
            switch (item.status) {
              case "Pendente":
                acc.pendente++;
                break;
              case "Resolvido":
                acc.resolvido++;
                break;
              case "Aguardando Análise":
                acc.agdAnalise++;
                break;
              default:
                break;
            }
            return acc;
          },
          { ...initialCount },
        );
        setContTickets({
          pendente: statusCounts?.pendente || 0,
          resolvido: statusCounts?.resolvido || 0,
          agdAnalise: statusCounts?.agdAnalise || 0,
          total:
            statusCounts?.pendente +
              statusCounts?.resolvido +
              statusCounts?.agdAnalise || 0,
        });
        break;
      case "IXC":
        initialCount = {
          aberto: 0,
          encaminhado: 0,
          agendado: 0,
          reagendar: 0,
          emAnalise: 0,
          assumido: 0,
          emExecucao: 0,
          finalizado: 0,
          na: 0,
          deslocamento: 0,
        };

        statusCounts = allTickets?.atendimentos?.reduce(
          (acc, item) => {
            switch (item.status) {
              case "Aberto":
                acc.aberto++;
                break;
              case "Encaminhado":
                acc.encaminhado++;
                break;
              case "Agendado":
                acc.agendado++;
                break;
              case "Reagendar":
                acc.reagendar++;
                break;
              case "Em Análise":
                acc.emAnalise++;
                break;
              case "Assumido":
                acc.assumido++;
                break;
              case "Em execução":
                acc.emExecucao++;
                break;
              case "Finalizado":
                acc.finalizado++;
                break;
              case "N/A":
                acc.na++;
                break;
              case "Deslocamento":
                acc.deslocamento++;
                break;
              default:
                break;
            }
            return acc;
          },
          { ...initialCount },
        );

        setContTickets({
          aberto: statusCounts?.aberto || 0,
          encaminhado: statusCounts?.encaminhado || 0,
          agendado: statusCounts?.agendado || 0,
          reagendar: statusCounts?.reagendar || 0,
          emAnalise: statusCounts?.emAnalise || 0,
          assumido: statusCounts?.assumido || 0,
          emExecucao: statusCounts?.emExecucao || 0,
          finalizado: statusCounts?.finalizado || 0,
          na: statusCounts?.na || 0,
          deslocamento: statusCounts?.deslocamento || 0,
          total:
            (statusCounts?.aberto || 0) +
            (statusCounts?.encaminhado || 0) +
            (statusCounts?.agendado || 0) +
            (statusCounts?.reagendar || 0) +
            (statusCounts?.emAnalise || 0) +
            (statusCounts?.assumido || 0) +
            (statusCounts?.emExecucao || 0) +
            (statusCounts?.finalizado || 0) +
            (statusCounts?.na || 0) +
            (statusCounts?.deslocamento || 0),
        });
        break;
    }
  }, [allTickets]);

  useEffect(() => {
    if (!carregado) return;
    const selectedClientStorage = JSON.parse(
      localStorage.getItem("filterData"),
    );
    if (selectedClientStorage) {
      // Cliente salvo de outro ERP não é restaurado.
      const selectClient = clientes?.find(
        (cliente) =>
          cliente?.id === selectedClientStorage?.clienteId &&
          (!erpId || cliente?.erpId === erpId),
      );

      setSelectedCliente(selectClient || null);
      setSelectedService(selectedClientStorage?.serviceId);
    }
  }, [clientes, carregado]);

  // Troca de ERP: limpa cliente, serviço e OS (e o cliente salvo, se for de
  // outro ERP).
  const handleChangeErp = (novoErpId) => {
    if (!novoErpId || novoErpId === erpId) return;
    const selectedClientStorage = JSON.parse(
      localStorage.getItem("filterData"),
    );
    const clienteSalvo = clientes?.find(
      (cliente) => cliente?.id === selectedClientStorage?.clienteId,
    );
    if (clienteSalvo && clienteSalvo?.erpId !== novoErpId) {
      localStorage.removeItem("filterData");
    }
    setSelectedCliente(null);
    setSelectedService(null);
    setAllServiceCliente([]);
    setAllTickets({});
    setErpId(novoErpId);
  };

  useEffect(() => {
    setPage(1);
  }, [buscarTicket, value]); // Também reseta ao mudar de aba (value)

  useEffect(() => {
    apiGetClientes();

    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      if (controllerDashboard) {
        controllerDashboard.abort();
      }
    };
  }, []);
  useEffect(() => {
    const now = dayjs();
    setIsValidRange(
      dayjs.isDayjs(startDate) &&
        dayjs.isDayjs(endDate) &&
        startDate.isValid() &&
        endDate.isValid() &&
        !startDate.isAfter(endDate) &&
        !endDate.isBefore(startDate) &&
        !startDate.isAfter(now) &&
        !endDate.isAfter(now),
    );
  }, [endDate, startDate]);

  useEffect(() => {
    if (selectedCliente?.cnpj && !loadingGetTickets) {
      const isAllTickets =
        selectTime === 0 && selectTime !== null ? true : false;

      switch (erp) {
        case "VOALLE":
          getTickets(
            selectedCliente?.cnpj,
            filterData?.initialDate,
            filterData?.finalDate,
            isAllTickets,
          );
          getServicesCliente(selectedCliente?.cnpj);
          break;
        case "HUBSOFT":
          getTickets(
            selectedCliente?.cnpj,
            filterData?.initialDate,
            filterData?.finalDate,
            isAllTickets,
          );
          getServicesCliente(selectedCliente?.cnpj);
          break;
        case "IXC":
          getTickets(
            null,
            filterData?.initialDate,
            filterData?.finalDate,
            isAllTickets,
            selectedCliente?.clienteErpId,
          );
          getServicesCliente(null, selectedCliente?.clienteErpId);
          break;
        default:
          setSnackbar({
            children: "ERP não configurado",
            severity: "warning",
          });
      }
    }
    localStorage.setItem("selectedClient", JSON.stringify(selectedCliente));
  }, [selectedCliente, filterData]);

  const handleClick = (event) => {
    setAnchorEl(event?.currentTarget);
  };

  const handleClose = (e) => {
    setAnchorEl(null);
  };

  const handleStartChange = (newValue) => {
    setStartDate(newValue);
    if (newValue?.isAfter(endDate)) {
      setEndDate(newValue);
    }
  };
  const handleEndChange = (newValue) => {
    setEndDate(newValue);
  };

  const handleAplicar = () => {
    setFilterData((prev) => ({
      ...prev,
      initialDate: dayjs(startDate).toDate(),
      finalDate: dayjs(endDate).set("minute", 59).set("hour", 23).toDate(),
    }));
    setSelectTime(null);
    handleClose();
  };

  const handleSelectTime = (key) => {
    setSelectTime(key);
    setStartDate(null);
    setEndDate(null);
    handleClose();

    setFilterData((prev) => ({
      ...prev,
      initialDate: optionsTime[key]?.value,
      finalDate: dayjs().set("second", 0).set("millisecond", 0).toDate(),
    }));
  };

  const getTickets = async (
    cnpjClient,
    initialDate,
    finalDate,
    isAllTickets,
    clienteErpId,
  ) => {
    setLoadingGetTickets(true);
    setSelectedService(null);
    try {
      setLoading(true);
      setPage(1);
      const response = await api.post("/interno/find/Os", {
        clienteId: selectedCliente?.id,
        erpId: erpId || undefined,
        cnpjClient: cnpjClient,
        clienteErpId: clienteErpId,
        initialDate: dayjs(initialDate)
          .set("hour", 0)
          .set("minute", 0)
          .set("second", 0)
          .set("millisecond", 0)
          .toDate(),
        finalDate: dayjs(finalDate)
          .set("hour", 23)
          .set("minute", 59)
          .set("second", 59)
          .set("millisecond", 59)
          .toDate(),
        isAllTickets: isAllTickets,
      });
      setAllTickets(response?.data);

      setContTickets({
        pendente: response?.data?.statusCounts?.pendente || 0,
        resolvido: response?.data?.statusCounts?.resolvido || 0,
        agdAnalise: response?.data?.statusCounts?.agdAnalise || 0,
        total:
          response?.data?.statusCounts?.pendente +
            response?.data?.statusCounts?.resolvido +
            response?.data?.statusCounts?.agdAnalise || 0,
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setLoadingGetTickets(false);
    }
  };

  const apiGetClientes = async () => {
    setLoading(true);
    if (controllerDashboard) {
      controllerDashboard.abort();
    }
    const newController = new AbortController();
    const signal = newController.signal;
    setControllerDashboard(newController);
    try {
      const response = await api.get("/interno/getClients", { signal });

      // O cliente salvo é restaurado no efeito de `clientes` (depende do ERP).
      setClientes(response.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const getServicesCliente = async (cnpj, clienteErpId) => {
    if (controllerDashboard) {
      controllerDashboard.abort();
    }

    const newController = new AbortController();
    const signal = newController.signal;
    setControllerDashboard(newController);
    setLoadingService(true);
    try {
      const response = await api.post(
        "/interno/find/allServiceClient",
        {
          clienteId: selectedCliente?.id,
          erpId: erpId || undefined,
          cnpj: cnpj,
          idClienteErp: clienteErpId,
        },
        {
          signal,
        },
      );

      setAllServiceCliente(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingService(false);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setPage(1);
  };

  const handleChangePagination = (event, newPage) => {
    setPage(newPage);
  };

  const getTicketDetails = async (ticketId) => {
    try {
      const response = await api.post("/interno/find/os/id", {
        ticketId: ticketId,
        erpId: erpId || undefined,
      });

      return response?.data;
    } catch (error) {
      console.log(error);
      setSnackbar({
        children: "Error: Não foi possível localizar detalhes do ticket",
        severity: "error",
      });
    } finally {
    }
  };
  const refrashTickets = () => {
    if (selectedCliente?.cnpj && !loadingGetTickets) {
      const isAllTickets =
        selectTime === 0 && selectTime !== null ? true : false;

      switch (erp) {
        case "VOALLE":
          getTickets(
            null,
            filterData?.initialDate,
            filterData?.finalDate,
            isAllTickets,
            selectedCliente?.clienteErpId,
          );
          getServicesCliente(null, selectedCliente?.clienteErpId);
          break;
        case "HUBSOFT":
          getTickets(
            selectedCliente?.cnpj,
            filterData?.initialDate,
            filterData?.finalDate,
            isAllTickets,
          );
          getServicesCliente(selectedCliente?.cnpj);
          break;
        case "IXC":
          getTickets(
            null,
            filterData?.initialDate,
            filterData?.finalDate,
            isAllTickets,
            selectedCliente?.clienteErpId,
          );
          getServicesCliente(null, selectedCliente?.clienteErpId);
          break;
        default:
          setSnackbar({
            children: "ERP não configurado",
            severity: "warning",
          });
      }
    }
    localStorage.setItem("selectedClient", JSON.stringify(selectedCliente));
  };
  const handleOpenNewTicket = () => {
    setOpenNewTicket(true);
  };
  const handleCloseNewTicket = () => {
    setOpenNewTicket(false);
  };

  const actions = [
    {
      icon: <FilterAltOutlinedIcon />,
      name: "Filtro",
      onClick: () => setOpenFilter(true),
    },
    ...(erp === "HUBSOFT" || erp === "IXC"
      ? [
          {
            icon: <AddOutlined />,
            name: "Novo OS",
            onClick: () => handleOpenNewTicket(),
          },
        ]
      : []),
  ];
  return (
    <Box sx={styles.containerPageTickets}>
      <FilterBar
        actions={actions}
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        type={1}
        selectorComponentLeft={
          <Box
            sx={{
              display: "flex",
              "@media (max-width: 1349px)": { flexDirection: "column" },
              gap: 1,

              width: "100%",
            }}
          >
            {variosErps && (
              <ErpFilter
                erps={erps}
                value={erpId}
                onChange={handleChangeErp}
                limpavel={false}
                id="filtro-erp-os"
                sx={{ minWidth: 200 }}
              />
            )}
            <VirtualizedAutocomplete
              disabled={loadingGetTickets}
              sx={{
                width: "100%",
                maxWidth: 500,
              }}
              value={selectedCliente}
              onChange={(_, newValue) => {
                setSelectedCliente(newValue);
                const clientStorage = {
                  interfaceId: "",
                  clienteId: newValue?.id,
                  hostId: "",
                  serviceId: "",
                  selectTime: 5,
                  initialDate: "",
                  finalDate: "",
                };

                localStorage.setItem(
                  "filterData",
                  JSON.stringify(clientStorage),
                );
              }}
              clearIcon={
                <Clear
                  onClick={() => {
                    setSelectedCliente(null);
                    setSelectedService(null);
                    setAllTickets([]);
                    localStorage.removeItem("filterData");
                  }}
                />
              }
              size="small"
              options={
                // Só os clientes do ERP escolhido.
                Array.isArray(clientes)
                  ? clientes.filter(
                      (cliente) =>
                        !cliente?.isGrupoEconomico &&
                        (!erpId || cliente?.erpId === erpId),
                    )
                  : []
              }
              // Mesma opção de cliente da tela de tickets (selo PF/PJ).
              getOptionLabel={(option) => getClienteOptionLabel(option)}
              renderOption={renderOpcaoCliente()}
              renderInput={(params) => (
                <CampoCliente
                  params={params}
                  option={selectedCliente}
                  label="Cliente"
                  sx={{
                    fontSize: "0.75rem", // diminui fonte geral
                  }}
                />
              )}
            />
            <Autocomplete
              disabled={loadingGetTickets}
              sx={{
                width: "100%",
                maxWidth: 500,
              }}
              value={
                (Array.isArray(allServicesCliente) &&
                  allServicesCliente?.find(
                    (service) =>
                      service?.id_cliente_servico?.toString() ===
                      selectedService?.toString(),
                  )) ||
                null
              }
              getOptionLabel={(option) =>
                option ? `${option?.id_cliente_servico} - ${option?.nome}` : ""
              }
              onChange={(_, newValue) => {
                setSelectedService(newValue?.id_cliente_servico?.toString());

                const filterDataStorage = JSON.parse(
                  localStorage.getItem("filterData"),
                );
                const newFilterData = {
                  ...filterDataStorage,
                  serviceId: newValue?.id_cliente_servico?.toString(),
                  interfaceId: "",
                  hostId: "",
                };

                localStorage.setItem(
                  "filterData",
                  JSON.stringify(newFilterData),
                );
              }}
              clearIcon={
                <Clear
                  onClick={() => {
                    const filterDataStorage = JSON.parse(
                      localStorage.getItem("filterData"),
                    );
                    const newFilterData = {
                      ...filterDataStorage,
                      serviceId: "",
                    };

                    localStorage.setItem(
                      "filterData",
                      JSON.stringify(newFilterData),
                    );
                    setSelectedService(null);
                  }}
                />
              }
              size="small"
              options={
                Array.isArray(allServicesCliente) ? allServicesCliente : []
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={labelErp}
                  size="small"
                  sx={{
                    fontSize: "0.75rem", // diminui fonte geral
                  }}
                />
              )}
              filterOptions={(options, params) => {
                // Se a pesquisa normal não encontrar nada, ou se você quiser forçar a busca em outros campos:
                return options.filter(
                  (option) =>
                    option.nome
                      ?.toLowerCase()
                      .includes(params.inputValue.toLowerCase()) ||
                    option.id_cliente_servico
                      ?.toString()
                      .includes(params.inputValue) ||
                    option.referencia
                      ?.toLowerCase()
                      .includes(params.inputValue.toLowerCase()),
                );
              }}
              renderOption={(props, option) => {
                const { key, ...optionProps } = props;

                // Se não houver referência, renderiza o formato simples (padrão)
                if (!option.referencia) {
                  return (
                    <li key={key} {...optionProps}>
                      {`${option.id_cliente_servico} - ${option.nome}`}
                    </li>
                  );
                }

                // Se houver referência, renderiza o formato personalizado
                return (
                  <li key={key} {...optionProps}>
                    <Box sx={styles.boxLine}>
                      <span style={{ fontWeight: "bold" }}>
                        {`${option.id_cliente_servico} - ${option.nome}`}
                      </span>
                      {option.referencia?.trim() && (
                        <>
                          <Divider sx={{ margin: "2px 0" }} />
                          <span style={{ fontSize: "0.85rem", opacity: 0.9 }}>
                            <span style={{ fontWeight: "bold" }}>
                              {configErp(option?.invertInfo).labelRef}:
                            </span>{" "}
                            {option.referencia}
                          </span>
                        </>
                      )}
                    </Box>
                  </li>
                );
              }}
            />
            <TextField
              id="input-with-icon-textfield"
              size="small"
              label="Buscar ticket"
              variant="outlined"
              autoComplete="off"
              placeholder="Protocolo, descrição, etc..."
              sx={{
                width: "100%",
                maxWidth: 500,

                display: "flex",
                flexGrow: 1,
                fontSize: "0.90rem", // diminui fonte geral

                "@media (max-width: 1349px)": {
                  width: "100%",
                },
              }}
              value={buscarTicket}
              onChange={(event) => {
                setBuscarTicket(event?.target?.value?.trimStart());
              }}
              InputProps={{
                endAdornment: buscarTicket ? (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={() => setBuscarTicket("")}
                      edge="end"
                    >
                      <Clear size={"small"} />
                    </IconButton>
                  </InputAdornment>
                ) : null,
              }}
            />
          </Box>
        }
        selectorComponentRight={
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <ButtonTime
              open={open}
              optionsTime={optionsTime}
              selectTime={selectTime}
              handleClick={handleClick}
              anchorEl={anchorEl}
              handleClose={handleClose}
              loading={loading}
              handleStartChange={handleStartChange}
              handleEndChange={handleEndChange}
              handleAplicar={handleAplicar}
              isValidRange={isValidRange}
              endDate={endDate}
              startDate={startDate}
              setEndDate={setEndDate}
              setStartDate={setStartDate}
              setSelectTime={setSelectTime}
              handleSelectTime={handleSelectTime}
              filterData={filterData}
              DateTime={DatePicker}
            />
            {(erp === "HUBSOFT" || erp === "IXC") && (
              <>
                <Tooltip title="Novo OS">
                  <Button
                    startIcon={<AddOutlined fontSize="small" />}
                    variant="contained"
                    disabled={loading}
                    sx={{ whiteSpace: "nowrap", height: "40px" }}
                    onClick={() => handleOpenNewTicket()}
                  >
                    Novo OS
                  </Button>
                </Tooltip>
              </>
            )}
          </Box>
        }
      />
      {erp === "HUBSOFT" && (
        <Grid
          container
          spacing={1}
          columns={{ xs: 2, sm: 4, md: 6, lg: 6, xl: 6, xxl: 6 }}
        >
          <Grid item xs={2} sm={4} md={6} lg={2}>
            <CardsStatusTicketComponet
              titleCard="Resolvidos"
              typeCard={1}
              icon={CheckOutlined}
              valueCard={countTickets?.resolvido || 0}
              valueTotal={countTickets?.total}
              loading={loading}
            />
          </Grid>
          <Grid item xs={2} sm={4} md={3} lg={2}>
            <CardsStatusTicketComponet
              titleCard="Aguardando análise"
              typeCard={2}
              icon={AccessTimeOutlined}
              valueCard={countTickets?.agdAnalise}
              valueTotal={countTickets?.total}
              loading={loading}
            />
          </Grid>
          <Grid item xs={2} sm={4} md={3} lg={2}>
            <CardsStatusTicketComponet
              titleCard="Pendentes"
              typeCard={3}
              icon={ErrorOutlineOutlined}
              valueCard={countTickets?.pendente}
              valueTotal={countTickets?.total}
              loading={loading}
            />
          </Grid>
        </Grid>
      )}
      {erp === "IXC" && (
        <Grid
          container
          spacing={1}
          columns={{ xs: 2, sm: 4, md: 4, lg: 10, xl: 10, xxl: 10 }}
        >
          <Grid item xs={2} sm={2} md={2} lg={2}>
            <CardsStatusTicketComponet
              titleCard="Finalizado"
              typeCard={1}
              icon={CheckOutlined}
              valueCard={countTickets?.finalizado}
              valueTotal={countTickets?.total}
              loading={loading}
            />
          </Grid>
          <Grid item xs={2} sm={2} md={2} lg={2}>
            <CardsStatusTicketComponet
              titleCard="Aberto"
              typeCard={3}
              icon={ErrorOutlineOutlined}
              valueCard={countTickets?.aberto}
              valueTotal={countTickets?.total}
              loading={loading}
            />
          </Grid>
          <Grid item xs={2} sm={2} md={2} lg={2}>
            <CardsStatusTicketComponet
              titleCard="Agendado"
              typeCard={2}
              icon={DateRangeOutlined}
              valueCard={countTickets?.agendado}
              valueTotal={countTickets?.total}
              loading={loading}
            />
          </Grid>

          <Grid item xs={2} sm={2} md={2} lg={2}>
            <CardsStatusTicketComponet
              titleCard="Em análise"
              typeCard={5}
              icon={TroubleshootOutlined}
              valueCard={countTickets?.emAnalise}
              valueTotal={countTickets?.total}
              loading={loading}
            />
          </Grid>

          <Grid item xs={2} sm={2} md={2} lg={2}>
            <CardsStatusTicketComponet
              titleCard="Encaminhado"
              typeCard={4}
              icon={TurnSlightRightOutlined}
              valueCard={countTickets?.encaminhado}
              valueTotal={countTickets?.total}
              loading={loading}
            />
          </Grid>
          <Grid item xs={2} sm={2} md={2} lg={2}>
            <CardsStatusTicketComponet
              titleCard="Assumido"
              typeCard={6}
              icon={SupportAgentOutlined}
              valueCard={countTickets?.assumido}
              valueTotal={countTickets?.total}
              loading={loading}
            />
          </Grid>
          <Grid item xs={2} sm={2} md={2} lg={2}>
            <CardsStatusTicketComponet
              titleCard="Reagendar"
              typeCard={9}
              icon={EventRepeatOutlined}
              valueCard={countTickets?.reagendar}
              valueTotal={countTickets?.total}
              loading={loading}
            />
          </Grid>

          <Grid item xs={2} sm={2} md={2} lg={2}>
            <CardsStatusTicketComponet
              titleCard="Deslocamento"
              typeCard={8}
              icon={PersonPinCircleOutlined}
              valueCard={countTickets?.deslocamento}
              valueTotal={countTickets?.total}
              loading={loading}
            />
          </Grid>
          <Grid item xs={2} sm={2} md={2} lg={2}>
            <CardsStatusTicketComponet
              titleCard="Em execução"
              typeCard={7}
              icon={ManageHistoryOutlined}
              valueCard={countTickets?.emExecucao}
              valueTotal={countTickets?.total}
              loading={loading}
            />
          </Grid>

          <Grid item xs={2} sm={2} md={2} lg={2}>
            <CardsStatusTicketComponet
              titleCard="N/A"
              typeCard={10}
              icon={ClearOutlined}
              valueCard={countTickets?.na}
              valueTotal={countTickets?.total}
              loading={loading}
            />
          </Grid>
        </Grid>
      )}

      <Box sx={{ marginTop: "10px" }}>
        <Grid
          container
          spacing={1}
          columns={{ xs: 8, sm: 8, md: 8, lg: 9, xl: 9, xxl: 9 }}
        >
          <Grid item xs={8} sm={5} md={5} lg={7}>
            <Box sx={styles.containerTabs}>
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable tabs"
                allowScrollButtonsMobile
              >
                <Tab label="Abertos" />
                <Tab label="Resolvidos" />
                <Tab label="Todos" />
              </Tabs>
            </Box>
          </Grid>
        </Grid>

        {loading ? (
          <Box sx={styles.boxLoading}>
            <LoaderThreeDots />
          </Box>
        ) : selectedCliente && paginatedRows?.length === 0 && buscarTicket ? (
          <Box sx={styles.containerNoTickets}>
            <Box
              sx={styles.paperNoTickets}
              elevation={theme.palette.mode === "dark" ? 0 : 3}
            >
              <Box sx={styles.containerImgNoTickets}>
                <ConfusedMale
                  mainFill={theme.palette.secondary.dark}
                  primaryCircleFill={theme.palette.secondary.main}
                  highlightTitle={"Oops !"}
                  subtitle={`Parece que não\nencontramos nenhum\nticket.`}
                />
              </Box>
            </Box>
          </Box>
        ) : paginatedRows?.length === 0 && selectedCliente ? (
          <Box sx={styles.containerNoTickets}>
            <Box
              sx={styles.paperNoTickets}
              elevation={theme.palette.mode === "dark" ? 0 : 3}
            >
              <Box sx={styles.containerImgNoTickets}>
                <ConfusedMale
                  mainFill={theme.palette.secondary.dark}
                  primaryCircleFill={theme.palette.secondary.main}
                  highlightTitle={"Oops !"}
                  subtitle={`Parece que não\nencontramos nenhum\nticket ${
                    value === 0 ? "em aberto." : value === 1 ? "resolvido." : ""
                  }`}
                />
              </Box>
            </Box>
          </Box>
        ) : !selectedCliente ? (
          <Box
            sx={{
              width: "100%",
              marginTop: 4,
            }}
          >
            <InformationMale
              mainFill={theme.palette.secondary.dark}
              primaryCircleFill={theme.palette.secondary.main}
              secondaryCircleFill={theme.palette.secondary.light}
              title={"Você ainda não selecionou um"}
              highlight={"cliente"}
              subtitle={
                "Os tickets aparecerão aqui assim que\num cliente for escolhido."
              }
            />
          </Box>
        ) : (
          <>
            <Grid
              container
              spacing={1}
              columns={{ xs: 2, sm: 4, md: 6, lg: 8, xl: 8, xxl: 12 }}
            >
              {paginatedRows?.map((ticket) => (
                <Grid
                  item
                  xs={2}
                  sm={2}
                  md={3}
                  lg={2}
                  key={ticket.id_atendimento}
                >
                  <TicketComponentIxc
                    protocolo={ticket?.protocolo}
                    descricao={ticket?.descricao_abertura}
                    assunto={ticket?.assunto}
                    setor={ticket?.setor}
                    filial={ticket?.filial}
                    prioridade={ticket?.prioridade}
                    sla={ticket?.sla}
                    id_ticket={ticket?.id_ticket}
                    cliente={ticket?.cliente?.nome || ""}
                    dataCadastro={dayjs(ticket?.data_cadastro).format(
                      "DD/MM/YYYY",
                    )}
                    isEdit={true}
                    selectedCliente={ticket?.isClienteAdd}
                    usuarioAbertura={ticket?.usuario_abertura}
                    status={ticket?.status}
                    ticketId={ticket?.id_atendimento}
                    getTicketDetails={getTicketDetails}
                    setSnackbar={setSnackbar}
                    servicoId={ticket?.idClienteServico || ""}
                    variantPaper="outlined"
                    labelErp={labelErp}
                    typeTitleModal={"Ordem de serviço"}
                    isOs={true}
                    erp={erp}
                    erpId={erpId || undefined}
                  />
                </Grid>
              ))}
            </Grid>
          </>
        )}
      </Box>
      {erp === "IXC" && (
        <ModalNewTicketIxc
          open={openNewTicket}
          handleClose={handleCloseNewTicket}
          refrashTIckets={refrashTickets}
          clienteErpId={selectedCliente?.clienteErpId}
          isOs={true}
          erp={erp}
          erpId={erpId || undefined}
        />
      )}

      {totalPages > 1 && !loading && (
        <Box sx={{ marginTop: "auto" }} display="flex" justifyContent="center">
          <Box sx={{ marginTop: "10px" }}>
            <Pagination
              count={totalPages}
              page={page}
              onChange={handleChangePagination}
              color="primary"
            />
          </Box>
        </Box>
      )}
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
    </Box>
  );
}
